import React, { useMemo } from 'react';
import './PartnerLogos.css';

const PartnerLogos = () => {
  // Generate array of logo URLs (1-31). Fixed order — a random shuffle here
  // causes a server/client hydration mismatch (React #418).
  const logoUrls = useMemo(
    () =>
      Array.from({ length: 31 }, (_, i) =>
        `https://storage.googleapis.com/lupatest/logos/logo${i + 1}.png`
      ),
    []
  );

  // Duplicate the logos array to create seamless infinite scroll
  const duplicatedLogos = [...logoUrls, ...logoUrls];

  return (
    <section className="partner-logos-section">
      <div className="partner-logos-container">
        <h2 className="partner-logos-title">Our Trusted Partners</h2>
        <div className="partner-logos-wrapper">
          <div className="partner-logos-track">
            {duplicatedLogos.map((url, index) => (
              <div key={`logo-${index}`} className="partner-logo-item">
                <img
                  src={url}
                  alt={`UBOTIKA technology partner logo ${(index % 31) + 1}`}
                  className="partner-logo-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;
